import React, { useEffect, useRef, useState } from "react";
import HealthIndicator from "./HealthIndicator";
import "./HealthScreenList.css"; // Assuming you have a CSS file for styles
import { forEach } from "async";
import ScreenHealthListFilter from "../ScreenHealthListFilter";
import { Tooltip } from "antd";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../../global/ProLanguageContext";

const HealthScreenList = (props) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).analytics;
  const {
    screens,
    selectedScreen = { ScreenID: -1 },
    onSelectScreen,
    parentProps,
    loading = false,
  } = props;
  const filterRef = useRef();
  const [filters, setFilters] = useState({
    branches: [],
    screens: [],
  });
  const getScreenAVGUpPercentage = (screen) => {
    console.log("getScreenAVGUpPercentage " + JSON.stringify(screen.data));
    if (!screen || !screen.data || screen.data.length === 0) return 0;
    const sumUpTime = screen.data.reduce(
      (acc, data) => acc + data.ActivePercentage,
      0,
    );
    const avgUpTime = sumUpTime / screen.data.length;
    return Math.round(avgUpTime * 100) / 100;
  };

  return (
    // <div className="screen-list-container">
    //   <div className="screen-list-header">
    //     <h2>Screens</h2>
    //     <span>{screens.length} total</span>
    //   </div>
    //   <div className="screen-list">
    //     {screens.map((screen) => (
    //       <div
    //         key={screen.ScreenID}
    //         className={`screen-item ${selectedScreen?.ScreenID === screen.ScreenID ? 'active' : ''}`}
    //         onClick={() => onSelectScreen(screen)}
    //       >
    //         <div>
    //           <div>{screen.ScreenName}</div>
    //           <div className="text-sm text-gray-500">{screen.BranchName}</div>
    //         </div>
    //         <div className="health-indicators">
    //           {screen.data.map((data, index) => (
    //             <HealthIndicator key={index} data={data} />
    //           ))}
    //         </div>
    //       </div>
    //     ))}
    //   </div>
    // </div>
    <div className="card" style={{ width: "100%" }}>
      <div
        className="card-header"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div>
          <h2 className="card-title">{t.listTitle}</h2>
          <p className="card-subtitle">{t.listSubtitle}</p>
        </div>
        <div>
          <ScreenHealthListFilter
            ref={filterRef}
            onFilterChange={setFilters}
            parentProps={parentProps}
          ></ScreenHealthListFilter>
        </div>
      </div>

      <div className="card-body">
        <table className="table">
          <thead className="table-head">
            <tr>
              <th className="table-th" style={{ textAlign: "left" }}>
                {t.colScreen}
              </th>
              <th className="table-th">
                {t.colConnectivity} <br />
                <small>{t.colConnectivitySub}</small>
              </th>
              <th className="table-th">{t.colUptime}</th>
              <th className="table-th">{t.colRam}</th>
              <th className="table-th">{t.colStorage}</th>
              <th className="table-th">{t.colCPU}</th>
            </tr>
          </thead>
          <tbody className="table-body">
            {screens
              .filter((s) => {
                var result = true;
                if (filters.branches && filters.branches.length) {
                  console.log(
                    "filter branches " + JSON.stringify(filters.branches),
                  );
                  console.log("screen branches " + JSON.stringify(s.BranchID));
                  result = result && filters.branches.includes(s.BranchID);
                }
                if (filters.screens && filters.screens.length) {
                  result = result && filters.screens.includes(s.ScreenID);
                }

                return result;
              })
              .map((screen, index) => {
                // JSON.stringify(screen)
                const dataFB = screen.DataFirebase ? screen.DataFirebase : {};
                var roundedAvgUpTime = getScreenAVGUpPercentage(screen);
                var roundedRamUsed =
                  "ram_used" in dataFB && "ram_total" in dataFB
                    ? Math.round((dataFB.ram_used / dataFB.ram_total) * 100)
                    : -1;
                var roundedStorageUsed =
                  "storage_used" in dataFB && "storage_total" in dataFB
                    ? Math.round(
                        (dataFB.storage_used / dataFB.storage_total) * 100,
                      )
                    : -1;
                var roundedCPUUsed =
                  "cpu_used" in dataFB && "cpu_total" in dataFB
                    ? Math.round((dataFB.cpu_used / dataFB.cpu_total) * 100)
                    : -1;
                return (
                  <tr
                    key={screen.ScreenID}
                    onClick={() => onSelectScreen(screen.ScreenID)}
                    className={`table-row ${selectedScreen && selectedScreen.ScreenID === screen.ScreenID ? "selected" : ""}`}
                  >
                    <td className="table-td">
                      <Tooltip title={`${screen.ScreenName}`}>
                        <div className="screen-info ellipsis">
                          <div className="screen-name ellipsis">
                            {screen.ScreenName}
                          </div>
                          <div className="screen-location ellipsis">
                            {screen.BranchName}
                          </div>
                        </div>
                      </Tooltip>
                    </td>
                    <td className="table-td">
                      <div className="health-indicators">
                        {screen.data.map((data, index) => (
                          <HealthIndicator key={index} data={data} />
                        ))}
                      </div>
                    </td>
                    <td className="table-td">
                      <span
                        className={`uptime-badge ${
                          roundedAvgUpTime >= 99
                            ? "uptime-good"
                            : roundedAvgUpTime >= 70
                              ? "uptime-warning"
                              : "uptime-bad"
                        }`}
                      >
                        {roundedAvgUpTime}%
                      </span>
                    </td>
                    <td className="table-td">
                      <span
                        className={`uptime-badge ${
                          roundedRamUsed == -1
                            ? "uptime-none"
                            : roundedRamUsed <= 70
                              ? "uptime-good"
                              : roundedRamUsed <= 90
                                ? "uptime-warning"
                                : "uptime-bad"
                        }`}
                      >
                        {roundedRamUsed > -1 ? `${roundedRamUsed}%` : "N/A"}
                      </span>
                    </td>
                    <td className="table-td">
                      <span
                        className={`uptime-badge ${
                          roundedStorageUsed == -1
                            ? "uptime-none"
                            : roundedStorageUsed <= 70
                              ? "uptime-good"
                              : roundedStorageUsed <= 90
                                ? "uptime-warning"
                                : "uptime-bad"
                        }`}
                      >
                        {roundedStorageUsed > -1
                          ? `${roundedStorageUsed}%`
                          : "N/A"}
                      </span>
                    </td>
                    <td className="table-td">
                      <span
                        className={`uptime-badge ${
                          roundedCPUUsed == -1
                            ? "uptime-none"
                            : roundedCPUUsed <= 70
                              ? "uptime-good"
                              : roundedCPUUsed <= 90
                                ? "uptime-warning"
                                : "uptime-bad"
                        }`}
                      >
                        {roundedCPUUsed > -1 ? `${roundedCPUUsed}%` : "N/A"}
                      </span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HealthScreenList;
